import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { Button, type ButtonProps } from './Button';
import { Popover, PopoverContent, PopoverTrigger } from './Popover';
import { cn } from '@/shared/utils/utils';

export interface SplitButtonMenuItem {
  label: string;
  icon?: React.ReactNode;
  onClick: () => void;
  disabled?: boolean;
}

interface SplitButtonProps extends ButtonProps {
  menuItems: SplitButtonMenuItem[];
  menuAlign?: 'start' | 'center' | 'end';
}

export const SplitButton = ({
  menuItems,
  menuAlign = 'end',
  children,
  variant,
  size,
  className,
  ...primaryProps
}: SplitButtonProps) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="flex items-center">
      <Button
        variant={variant}
        size={size}
        className={cn('rounded-e-none', className)}
        {...primaryProps}
      >
        {children}
      </Button>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button
            variant={variant}
            size={size}
            className={cn(
              'rounded-s-none border-s border-s-white/30 px-2',
              className
            )}
          >
            <ChevronDown className="h-4 w-4" />
          </Button>
        </PopoverTrigger>
        <PopoverContent align={menuAlign} className="w-48 p-1">
          {menuItems.map((item) => (
            <button
              key={item.label}
              disabled={item.disabled}
              className="flex w-full items-center gap-2 rounded px-3 py-2 text-sm hover:bg-accent disabled:opacity-50 disabled:pointer-events-none"
              onClick={() => {
                setOpen(false);
                item.onClick();
              }}
            >
              {item.icon}
              {item.label}
            </button>
          ))}
        </PopoverContent>
      </Popover>
    </div>
  );
};
